/* eslint-disable import/no-default-export */
import React from 'react';

const CompleteIcon = (props) => (
  <svg width={1920} height={1920} viewBox="0 0 1920 1920" {...props}>
    <path
      d="M578.16 1596.396c46.86 46.86 122.843 46.863 169.705 0L1850.952 493.31c46.869-46.868 46.863-122.842 0-169.705-46.86-46.86-122.842-46.863-169.705 0L663.013 1341.838l-424.26-424.26c-46.86-46.86-122.847-46.867-169.71-.004-46.86 46.86-46.86 122.844.005 169.71l509.107 509.107.005.005z"
      fill={props.color || 'currentColor'}
      fillRule="evenodd"
    />
  </svg>
);

export default CompleteIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/CompleteIcon.js